<h5 class="my-0" *ngIf="!producto.cargando">{{ producto.data.description_clear }}</h5>
<mat-dialog-content>
    <mat-spinner *ngIf="producto.cargando" class="d-block mx-auto my-3" diameter="20"></mat-spinner>
    <div *ngIf="!producto.cargando">
        <img class="img-producto mw-100" *ngIf="producto.data.imagenes.length == 0" src="/assets/img/producto-sin-imagen.svg">
        <owl-carousel-o *ngIf="producto.data.imagenes.length > 0" [options]="customOptions">
            <ng-container *ngFor="let imagen of producto.data.imagenes">
                <ng-template carouselSlide>
                    <img [src]="imagen.med" />
                </ng-template>
            </ng-container>
        </owl-carousel-o>
        <div>
            <strong>${{ producto.data.precio_final_con_impuesto_format }}</strong>&nbsp;&nbsp;&nbsp;
            <strong *ngIf="globals.configuracion.front.typeabbrev == '02' && producto.data.precio_unico == 0 && producto.data.precio_mayor != 0"><s>${{ producto.data.precio_detal_con_impuesto_format }}</s></strong>
        </div>
        <!--
        <div *ngIf="globals.configuracion.front.typeabbrev == '02' && producto.data.precio_unico == 0 && producto.data.precio_mayor != 0">
            <strong><s>${{ producto.data.precio_detal_con_impuesto_format }}</s></strong>
        </div>
        -->
		<form [formGroup]="form">
            <div class="grid-cantidad">
                <div class="row m-0">
                    <div class="col ps-0 pe-1">
                    </div>
                    <div class="lbl-cantidad col px-0">
                        Cantidad
                    </div>
                    <div class="col pe-0 ps-1">
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col ps-0 pe-1">
                        <button type="button" class="cursor-pointer" (click)="disminuirCantidad()">
                            <mat-icon>remove</mat-icon>
                        </button>
                    </div>
                    <div class="col px-0">
                        <input type="number" min="1" #cantidad formControlName="cantidad" (input)="inputEvent(cantidad.value)">
                    </div>
                    <div class="col pe-0 ps-1">
                        <button type="button" class="cursor-pointer" (click)="incrementarCantidad()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <h4 class="text-center my-1">Total</h4>
        <h2 class="text-center my-0">{{ producto.total }}</h2>
    </div>
    <mat-dialog-actions align="end">
        <mat-spinner *ngIf="formComportamiento.enviando" diameter="20" class="me-3"></mat-spinner>
        <button mat-raised-button color="primary" (click)="agregarProducto()" [disabled]="!form.valid || formComportamiento.enviando">Agregar</button>
        <!--<button mat-raised-button color="primary" (click)="agregarProductoCotizar()" [disabled]="!form.valid || formComportamiento.enviando">Agregar y Cotizar</button>-->
        <button mat-raised-button color="accent" (click)="seCerro()" mat-dialog-close>Volver</button>
    </mat-dialog-actions>
    <div *ngIf="producto.data.tags.length > 0" class="box-tags d-flex flex-wrap mt-4">
        
        <div class="flex-grow-1">
            <span class="tag-producto" *ngFor="let tag of producto.data.tags | slice:0:5">{{ tag.modeldescrip }}</span>
            <ng-container *ngIf="producto.data.tags.length > 5">
                <span class="tag-producto" [matMenuTriggerFor]="moreTags" (click)="masTags($event)">...</span>
                <mat-menu #moreTags="matMenu">
                    <button *ngFor="let tag of producto.data.tags | slice:5" mat-menu-item>{{ tag.modeldescrip }}</button>
                </mat-menu>
            </ng-container>
        </div>
        
    </div>
    <div class="detalle" *ngIf="producto.data.detalle" [innerHTML]='producto.data.detalle'>
    </div>
</mat-dialog-content>